import { Pipe, PipeTransform } from '@angular/core';
import { getLabel } from '../helpers/enum-helpers';

@Pipe({
    name: 'enumLabel',
    standalone: false
})
export class EnumLabelPipe implements PipeTransform {
    transform<TEnum>(value: TEnum, enumObj: any): unknown {
        return getLabel(enumObj, value);
    }
}
